import { authProviderType } from "@/providers/AuthenticationProvider";

export function isStaffMcpPlaygroundRuntime(): boolean {
  return authProviderType === "okta" || authProviderType === "token";
}

export function canAccessMcpPlayground(viewPeople: boolean, viewFacilities: boolean): boolean {
  return isStaffMcpPlaygroundRuntime() && viewPeople && viewFacilities;
}

export function isSupportedMcpPlaygroundWriteTool(tool: string): boolean {
  return tool === "create_person_note" || tool === "create_interaction" || tool === "create_task";
}

export function canConfirmMcpPlaygroundWrite(
  tool: string,
  managePeople: boolean,
  managePeopleInteractions: boolean,
  manageTasks = false
): boolean {
  if (tool === "create_person_note") {
    return managePeople;
  }

  if (tool === "create_interaction") {
    return managePeopleInteractions;
  }

  if (tool === "create_task") {
    return manageTasks;
  }

  return false;
}
